<template>
  <div class="pr-15">
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.road-list-report') }}</b>
      </template>
      <template #content>
        <div class="cols mb-10">
          <div class="rows mobile-cols align-items-start">
            <div class="cols align-items-start pr-5">
              <label for="vehicles">{{ $t('reports.events.vehicle') }}</label>
              <ChooseVehicles id="vehicles"
                              preselectAll
                              v-model="roadListReport.selectedVehicles">
              </ChooseVehicles>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateFrom">{{ $t('reports.events.date-from') }}</label>
              <Datepicker id="dateFrom"
                          v-model="roadListReport.dateFrom"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          :max-date="new Date()"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateTo">{{ $t('reports.events.date-to') }}</label>
              <Datepicker id="dateTo"
                          v-model="roadListReport.dateTo"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          :max-date="new Date()"
                          auto-apply/>
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportRoadListReport" :disabled="!isExportRoadListReportAllowed">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.important-events-report') }}</b>
      </template>
      <template #content>
        <div class="cols mb-10">
          <div class="rows mobile-cols align-items-start">
            <div class="cols align-items-start pr-5">
              <label for="vehicles">{{ $t('reports.events.vehicle') }}</label>
              <ChooseVehicles id="vehicles"
                              preselectAll
                              v-model="importantEventsReport.selectedVehicles">
              </ChooseVehicles>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateFrom">{{ $t('reports.events.date-from') }}</label>
              <Datepicker id="dateFrom"
                          v-model="importantEventsReport.dateFrom"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          :max-date="new Date()"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateTo">{{ $t('reports.events.date-to') }}</label>
              <Datepicker id="dateTo"
                          v-model="importantEventsReport.dateTo"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          :max-date="new Date()"
                          auto-apply/>
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportImportantEventsReport" :disabled="!isExportImportantEventsReportAllowed">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.monthly-vehicle-report') }}</b>
      </template>
      <template #content>
        <div class="cols mb-10">
          <div class="rows mobile-cols align-items-start">
            <div class="cols align-items-start pr-5">
              <label for="vehicles">{{ $t('reports.events.vehicle') }}</label>
              <ChooseVehicles id="vehicles"
                              preselectAll
                              v-model="monthlyVehicleReport.selectedVehicles">
              </ChooseVehicles>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateFrom">{{ $t('generic.date') }}</label>
              <Datepicker v-model="this.monthlyVehicleReport.selectedDate"
                          :locale="locale"
                          :max-date="new Date()"
                          month-picker
                          auto-apply />
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportMonthlyVehicleReport" :disabled="!isExportMonthlyVehicleReportAllowed">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.monthly-company-report') }}</b>
      </template>
      <template #content>
        <div class="cols mb-10">
          <div class="rows mobile-cols align-items-start">
            <div class="cols align-items-start pr-5">
              <label for="dateFrom">{{ $t('generic.date') }}</label>
              <Datepicker v-model="this.monthlyCompanyReport.selectedDate"
                          :locale="locale"
                          :max-date="new Date()"
                          month-picker
                          auto-apply />
            </div>
            <div class="cols pr-5 monthly-company-report-email">
              <label for="monthlyCompanyReportEmail">{{ $t('settings.on-board.users-email') }}</label>
              <input id="monthlyCompanyReportEmail" type="email" v-model="this.monthlyCompanyReport.email"/>
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportMonthlyCompanyReport" :disabled="!isExportMonthlyCompanyReportAllowed">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.engine-hours') }}</b>
      </template>
      <template #content>
        <div class="cols mb-10">
          <div class="rows mobile-cols align-items-start">
            <div class="cols align-items-start pr-5">
              <label for="vehicles">{{ $t('reports.events.vehicle') }}</label>
              <ChooseVehicles id="vehicles"
                              preselectAll
                              :vehicles-filter-callback="engineHoursVehicleFilter"
                              v-model="engineHoursReport.selectedVehicles">
              </ChooseVehicles>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateFrom">{{ $t('reports.events.date-from') }}</label>
              <Datepicker id="dateFrom"
                          v-model="engineHoursReport.dateFrom"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          :max-date="new Date()"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateTo">{{ $t('reports.events.date-to') }}</label>
              <Datepicker id="dateTo"
                          v-model="engineHoursReport.dateTo"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          :max-date="new Date()"
                          auto-apply/>
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportEngineHoursReport" :disabled="!isExportEngineHoursReportAllowed">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.tasks-report') }}</b>
      </template>
      <template #content>
        <div class="cols mb-10">
          <div class="rows mobile-cols align-items-start">
            <div class="cols align-items-start pr-5">
              <label for="status">
                {{ $t('task.status') }}
              </label>
              <ChooseTaskStatus id="status"
                                v-model="tasksReport.statusFilter"
                                :add-all-option="true" />
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateFrom">{{ $t('reports.events.date-from') }}</label>
              <Datepicker id="dateFrom"
                          v-model="tasksReport.dateFromFilter"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateTo">{{ $t('reports.events.date-to') }}</label>
              <Datepicker id="dateTo"
                          v-model="tasksReport.dateToFilter"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          :min-date="tasksReport.dateFromFilter"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="vehicle">{{ $t('task.vehicle') }}</label>
              <ChooseVehicles id="vehicle"
                              :preselectAll="false"
                              :single-select="true"
                              :add-all-option="true"
                              v-model="tasksReport.vehicleFilter" />
            </div>
            <div class="cols align-items-start pr-5">
              <label for="driver">
                {{ $t('task.driver') }}
              </label>
              <ChooseDriver id="driver"
                            v-model="tasksReport.driverFilter"
                            :add-all-option="true" />
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportTasksReport">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.vehicles-report') }}</b>
      </template>
      <template #content>
        <div class="cols mb-10">
          <div class="rows mobile-cols align-items-start">
            <div class="cols align-items-start pr-5">
              <label for="vehicles">{{ $t('reports.events.vehicle') }}</label>
              <ChooseVehicles id="vehicles"
                              preselectAll
                              v-model="vehiclesReport.selectedVehicles">
              </ChooseVehicles>
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportVehiclesReport" :disabled="!isExportVehiclesReportAllowed">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.drivers-report') }}</b>
      </template>
      <template #content>
        <div class="cols mb-10">
          <div class="rows mobile-cols align-items-start">
            <div class="cols align-items-start pr-5">
              <label for="dateFrom">{{ $t('reports.events.date-from') }}</label>
              <Datepicker id="dateFrom"
                          v-model="driversReport.dateFrom"
                          :format="$t('settings.generic.date-format')"
                          :locale="locale"
                          :max-date="driversReport.dateTo"
                          :time-picker="false"
                          :enable-time-picker="false"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateTo">{{ $t('reports.events.date-to') }}</label>
              <Datepicker id="dateTo"
                          v-model="driversReport.dateTo"
                          :format="$t('settings.generic.date-format')"
                          :locale="locale"
                          :min-date="driversReport.dateFrom"
                          :max-date="new Date()"
                          :time-picker="false"
                          :enable-time-picker="false"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="vehicle">{{ $t('settings.car-fleet.vehicle-name') }}</label>
              <ChooseVehicles id="vehicle"
                              :preselectAll="false"
                              :single-select="true"
                              :add-all-option="true"
                              v-model="driversReport.selectedVehicle" />
            </div>
            <div class="cols align-items-start pr-5">
              <label for="driver">
                {{ $t('reports.trips.result.driver') }}
              </label>
              <ChooseDriver id="driver"
                            v-model="driversReport.selectedDriver"
                            :add-all-option="true" />
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportDriversReport" :disabled="!isExportDriversReportAllowed">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
    <Accordion class="mb-10">
      <template #title>
        <b>{{ $t('reports.page.positions-data-chart') }}</b>
      </template>
      <template #content>
        <div class="cols positions-chart">
          <div class="rows">
            <div class="cols align-items-start pr-5">
              <label for="vehicles">{{ $t('reports.events.vehicle') }}</label>
              <ChooseVehicles id="vehicles"
                              :preselectAll="false"
                              :single-select="true"
                              v-model="positionAttributesReport.selectedVehicle">
              </ChooseVehicles>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateFrom">{{ $t('reports.events.date-from') }}</label>
              <Datepicker id="dateFrom"
                          v-model="positionAttributesReport.dateFrom"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="dateTo">{{ $t('reports.events.date-to') }}</label>
              <Datepicker id="dateTo"
                          v-model="positionAttributesReport.dateTo"
                          :format="$t('settings.generic.date-time-format')"
                          :locale="locale"
                          :min-date="positionAttributesReport.dateFrom"
                          auto-apply/>
            </div>
            <div class="cols align-items-start pr-5">
              <label for="positionsProps">{{ $t('generic.data') }}</label>
              <ChoosePositionProperties id="positionsProps"
                                        v-model="positionAttributesReport.selectedProperties"
                                        v-model:thresholds="positionAttributesReport.thresholds" />
            </div>
            <div class="cols align-items-start pr-5">
              <label>&nbsp;</label>
              <button @click="showVehiclesPropsChart" :disabled="!isShowVehiclePropsChartAllowed">
                {{ $t('reports.events.load') }}
              </button>
            </div>
            <div class="cols align-items-start">
              <label>&nbsp;</label>
              <button @click="exportVehiclesPropsChart" :disabled="!isShowVehiclePropsExportAllowed">
                {{ $t('reports.events.export') }}
              </button>
            </div>
          </div>
          <PositionsDataChart v-if="positionAttributesReport.processedPositions.length > 0"
                              :selected-props="positionAttributesReport.selectedProperties"
                              :positions="positionAttributesReport.processedPositions"
                              :prop-thresholds="positionChartThresholds"
                              :file-download-name="vehiclePropsExportName"
                              :position-click-options="positionChartClickOptions"
                              @position-clicked="onPositionChartClicked"
                              class="height-100p" />
        </div>

      </template>
    </Accordion>
  </div>
</template>

<script>

import Accordion from "@/components/pages/partials/Accordion.vue";
import ChooseVehicles from "@/components/pages/partials/ChooseVehicles.vue";
import Datepicker from "@vuepic/vue-datepicker";
import locale from "@/assets/js/locale";
import moment from "moment/moment";
import {mapGetters, mapState} from "vuex";
import {actions} from "@/assets/js/vue/vuex/actions";
import notification from "@/assets/js/notification";
import {dataManipulator, entityDataManager, WorkflowManager} from "@/assets/js/data-manipulation";
import ChooseTaskStatus from "@/components/pages/partials/ChooseTaskStatus.vue";
import ChooseDriver from "@/components/pages/partials/ChooseDriver.vue";
import {popups} from "@/assets/js/popups";
import ChoosePositionProperties from "@/components/pages/partials/ChoosePositionProperies.vue";
import PositionsDataChart from "@/components/pages/reports/report-components/PositionsDataChart.vue";
import {positionAttributes} from "@/assets/js/position-attributes";
import {utils, writeFileXLSX} from "xlsx";

export default {
  name: "ReportsPage",
  components: {
    PositionsDataChart,
    ChoosePositionProperties, ChooseDriver, ChooseTaskStatus, Datepicker, ChooseVehicles, Accordion},
  data() {
    return {
      locale: locale.getLocale(),
      roadListReport: {
        selectedVehicles: this.vehicles,
        dateFrom: moment().startOf('day').toDate(),
        dateTo: moment().endOf('day').toDate()
      },
      importantEventsReport: {
        selectedVehicles: this.vehicles,
        dateFrom: moment().startOf('day').toDate(),
        dateTo: moment().endOf('day').toDate()
      },
      monthlyVehicleReport: {
        selectedVehicles: this.vehicles,
        selectedDate: {
          month: this.getPreviousMonthDate().month(),
          year: this.getPreviousMonthDate().year()
        }
      },
      monthlyCompanyReport: {
        selectedDate: {
          month: this.getPreviousMonthDate().month(),
          year: this.getPreviousMonthDate().year()
        },
        email: null
      },
      engineHoursReport: {
        selectedVehicles: this.vehicles,
        dateFrom: moment().startOf('day').toDate(),
        dateTo: moment().endOf('day').toDate()
      },
      tasksReport: {
        statusFilter: null,
        dateFromFilter: moment().startOf('day').subtract(1, 'day').toDate(),
        dateToFilter: moment().endOf('day').subtract(1, 'day').toDate(),
        driverFilter: null,
        vehicleFilter: null,
      },
      vehiclesReport: {
        selectedVehicles: this.vehicles,
      },
      positionAttributesReport: {
        selectedVehicle: null,
        dateFrom: moment().startOf('day').toDate(),
        dateTo: moment().endOf('day').toDate(),
        selectedProperties: [],
        thresholds: {},
        resultPositions: [],
        resultOdometer: [],
        processedPositions: []
      },
      positionChartClickOptions: [
        {
          key: 'open-trips',
          value: 'reports.trips.result.trips'
        }
      ],
      driversReport: {
        selectedDriver: null,
        selectedVehicle: null,
        dateFrom: moment().startOf('day').subtract(1, 'day').toDate(),
        dateTo: moment().endOf('day').subtract(1, 'day').toDate()
      },
    }
  },
  computed: {
    ...mapState(['vehicles']),
    ...mapGetters(['userId', 'userEmail']),
    isExportRoadListReportAllowed() {
      return this.roadListReport.dateFrom !== null &&
          this.roadListReport.dateTo !== null &&
          this.roadListReport.selectedVehicles?.length > 0;
    },
    isExportImportantEventsReportAllowed() {
      return this.importantEventsReport.dateFrom !== null &&
          this.importantEventsReport.dateTo !== null &&
          this.importantEventsReport.selectedVehicles?.length > 0;
    },
    isExportMonthlyVehicleReportAllowed() {
      return this.monthlyVehicleReport.selectedDate?.month != null &&
          this.monthlyVehicleReport.selectedDate?.year != null &&
          this.monthlyVehicleReport.selectedVehicles?.length > 0;
    },
    isExportMonthlyCompanyReportAllowed() {
      return this.monthlyCompanyReport.selectedDate?.month != null &&
          this.monthlyCompanyReport.selectedDate?.year != null &&
          entityDataManager.isEmail(this.monthlyCompanyReport.email);
    },
    isExportEngineHoursReportAllowed() {
      return this.engineHoursReport.dateFrom !== null &&
          this.engineHoursReport.dateTo !== null &&
          this.engineHoursReport.selectedVehicles?.length > 0;
    },
    isExportVehiclesReportAllowed() {
      return this.vehiclesReport.selectedVehicles?.length > 0;
    },
    isShowVehiclePropsChartAllowed() {
      return this.positionAttributesReport.dateFrom !== null &&
          this.positionAttributesReport.dateTo !== null &&
          this.positionAttributesReport.selectedVehicle !== null &&
          this.positionAttributesReport.selectedProperties?.length > 0;
    },
    isShowVehiclePropsExportAllowed() {
      return this.isShowVehiclePropsChartAllowed && this.positionAttributesReport.processedPositions?.length > 0;
    },
    selectedPositionChartThresholdProps() {
      return this.positionAttributesReport.selectedProperties
          ?.filter(prop => this.canPositionPropHaveThreshold(prop)) ?? [];
    },
    positionChartThresholds() {
      return this.selectedPositionChartThresholdProps.reduce((result, prop) => {
        const threshold = this.positionAttributesReport.thresholds?.[prop.key] ?? {};
        result[prop.key] = {
          min: this.parseFloatOrNull(threshold.min),
          max: this.parseFloatOrNull(threshold.max),
        };

        return result;
      }, {});
    },
    vehiclePropsExportName() {
      const vehicle = entityDataManager.getById(this.vehicles, this.positionAttributesReport.selectedVehicle.id);
      return this.$t('reports.page.positions-data-chart') + ' - ' + vehicle.licensePlate;
    },
    isExportDriversReportAllowed() {
      return this.driversReport.dateFrom !== null &&
          this.driversReport.dateTo !== null;
    }
  },
  mounted() {
    this.monthlyCompanyReport.email = this.userEmail;
  },
  methods: {
    canPositionPropHaveThreshold(prop) {
      return prop?.showAsMarkArea !== true;
    },
    parseFloatOrNull(value) {
      if (value === '' || value == null) {
        return null;
      }

      const parsedValue = parseFloat(value);
      return Number.isFinite(parsedValue) ? parsedValue : null;
    },
    onPositionChartClicked(optionKey, positionData) {
      switch (optionKey) {
        case 'open-trips':
        {
          try {
            const from = moment(positionData.time).subtract(1, 'hour').toDate();
            const to = moment(positionData.time).add(1, 'hour').toDate();
            WorkflowManager.openTripsMapsInNewPage(positionData.deviceId, from, to, positionData.fixTime);
          }
          catch (e) {
            notification.error(this.$t(e.message))
          }
          break;
        }
      }
    },
    exportRoadListReport() {
      const payload = {
        userId: this.userId,
        deviceIds: this.roadListReport.selectedVehicles.map(x => x.deviceId),
        dateFrom: this.roadListReport.dateFrom,
        dateTo: this.roadListReport.dateTo
      };
      this.$store.dispatch(actions.GET_ROAD_LIST_REPORT, payload)
          .catch(e => notification.error(this.$t(e.message)));
    },
    exportImportantEventsReport() {
      const payload = {
        userId: this.userId,
        vehicleIds: this.importantEventsReport.selectedVehicles.map(x => x.id),
        dateFrom: this.importantEventsReport.dateFrom,
        dateTo: this.importantEventsReport.dateTo
      };
      this.$store.dispatch(actions.GET_IMPORTANT_EVENTS_REPORTS, payload)
          .catch(e => notification.error(this.$t(e.message)));
    },
    exportMonthlyVehicleReport() {
      const payload = {
        userId: this.userId,
        deviceIds: this.monthlyVehicleReport.selectedVehicles.map(x => x.deviceId),
        dateFrom: this.getFirstDateOfMonthYear(this.monthlyVehicleReport.selectedDate.year, this.monthlyVehicleReport.selectedDate.month),
        dateTo: this.getLastDateOfMonthYear(this.monthlyVehicleReport.selectedDate.year, this.monthlyVehicleReport.selectedDate.month)
      };
      this.$store.dispatch(actions.GET_MONTHLY_VEHICLE_REPORT, payload)
          .catch(e => notification.error(this.$t(e.message)));
    },
    exportMonthlyCompanyReport() {
      const payload = {
        userId: this.userId,
        dateFrom: this.getFirstDateOfMonthYear(this.monthlyCompanyReport.selectedDate.year, this.monthlyCompanyReport.selectedDate.month),
        dateTo: this.getLastDateOfMonthYear(this.monthlyCompanyReport.selectedDate.year, this.monthlyCompanyReport.selectedDate.month),
        email: this.monthlyCompanyReport.email
      };

      const messageTitle = this.$t('reports.page.report-is-generating');
      const messageDescription = `${this.$t('reports.page.expect-email')}: ${payload.email}`;
      this.$store.dispatch(actions.GET_MONTHLY_COMPANY_REPORT, payload)
          .then(() => popups.information(this.$swal, messageTitle, messageDescription))
          .catch(e => notification.error(this.$t(e.message)));
    },
    engineHoursVehicleFilter(vehicle) {
      return vehicle.engineHoursSupported;
    },
    exportEngineHoursReport() {
      const payload = {
        userId: this.userId,
        deviceIds: this.engineHoursReport.selectedVehicles.map(x => x.deviceId),
        dateFrom: this.engineHoursReport.dateFrom,
        dateTo: this.engineHoursReport.dateTo
      };
        this.$store.dispatch(actions.GET_ENGINE_HOURS_REPORT, payload)
            .catch(e => {
              notification.error(this.$t(e.message));
            });
    },
    exportTasksReport() {
      let filter = {}

      if (this.tasksReport.statusFilter) {
        filter.status = this.tasksReport.statusFilter;
      }

      if (this.tasksReport.dateFromFilter) {
        filter.dateFrom = dataManipulator.dateTimeToString(this.tasksReport.dateFromFilter);
      }

      if (this.tasksReport.dateToFilter) {
        filter.dateTo = dataManipulator.dateTimeToString(
            moment(this.tasksReport.dateToFilter).seconds(59).milliseconds(0).toDate(),
            true
        );
      }

      if (this.tasksReport.driverFilter?.id) {
        filter.driverId = this.tasksReport.driverFilter?.id;
      }

      if (this.tasksReport.vehicleFilter?.id) {
        filter.vehicleId = this.tasksReport.vehicleFilter?.id;
      }

      this.$store.dispatch(actions.GET_TASKS_REPORTS, filter)
          .catch(e => notification.error(this.$t(e.message)));
    },
    exportVehiclesReport() {
      const payload = {
        userId: this.userId,
        vehicleIds: this.vehiclesReport.selectedVehicles.map(x => x.id),
      };
      this.$store.dispatch(actions.GET_VEHICLES_REPORT, payload)
          .catch(e => notification.error(this.$t(e.message)));
    },
    exportDriversReport() {
      const payload = {
        dateFrom: this.driversReport.dateFrom,
        dateTo: this.driversReport.dateTo,
      };

      if (this.driversReport.selectedVehicle?.deviceId != null) {
        payload.deviceIds = [this.driversReport.selectedVehicle.deviceId];
      }

      if (this.driversReport.selectedDriver?.id != null) {
        payload.driverId = this.driversReport.selectedDriver.id;
      }

      this.$store.dispatch(actions.GET_DRIVERS_REPORT, payload)
          .catch(e => notification.error(this.$t(e.message)));
    },
    async showVehiclesPropsChart() {
      const payload = {
        deviceId: this.positionAttributesReport.selectedVehicle.deviceId,
        from: this.positionAttributesReport.dateFrom.toISOString(),
        to: this.positionAttributesReport.dateTo.toISOString()
      };

      await this.$store.dispatch(actions.GET_TRACCAR_POSITIONS, payload)
          .then(result => {
            this.positionAttributesReport.resultPositions = result ?? [];

            const payload = {
              id: this.positionAttributesReport.selectedVehicle.id,
              dateFrom: this.positionAttributesReport.dateFrom.toISOString(),
              dateTo: this.positionAttributesReport.dateTo.toISOString()
            };
            return this.$store.dispatch(actions.GET_VEHICLE_ODOMETER, payload)
                .then(result => this.positionAttributesReport.resultOdometer = result ?? []);
          })
          .then(() => {
            this.positionAttributesReport.processedPositions = positionAttributes.processPositions(
                this.positionAttributesReport.resultPositions,
                this.positionAttributesReport.selectedVehicle,
                this.positionAttributesReport.resultOdometer)
          })
          .catch(e => {
            this.positionAttributesReport.processedPositions = [];
            this.positionAttributesReport.resultPositions = [];
            this.positionAttributesReport.resultOdometer = [];
            return notification.error(this.$t(e.message));
          });
    },
    exportVehiclesPropsChart() {
      const timeFormat = this.$t('settings.generic.date-time-format-moment-extended');
      const headerData = [
          [this.positionAttributesReport.selectedVehicle.fullName,
            moment(this.positionAttributesReport.dateFrom.toISOString()).format(timeFormat),
            moment(this.positionAttributesReport.dateTo.toISOString()).format(timeFormat)],
          []
      ];

      const exportData = this.positionAttributesReport.processedPositions
          .map(pos => {
            const result = {[this.$t('reports.events.result.date')]: pos['time'].format(timeFormat)};

            this.positionAttributesReport.selectedProperties
                .forEach(prop => {
                  let data = pos[prop.key];
                  if (data == null) {
                    return;
                  }

                  const formatFn = prop.exportFormatFn ?? prop.tooltipFormatFn;
                  if (formatFn) {
                    data = formatFn(data);
                  }

                  result[this.$t(prop.descriptionKey)] = data;
                });

            return result;
          });

      const sheetName = this.vehiclePropsExportName;
      const wb = utils.book_new();

      const resultData = [...headerData, ...exportData];
      let ws = utils.aoa_to_sheet(headerData);
      ws = utils.sheet_add_json(ws, exportData, {origin: 2});

      const maxColWidths = resultData.reduce(
          (widths, row) => {
            Object.keys(row).forEach(
                (key, index) => {
                  if (widths[index] === undefined) {
                    widths[index] = key.length;
                  }

                  return widths[index] = Math.max(widths[index], row[key].toString().length);
                },
            );

            return widths;
          },
          {},
      );

      ws['!cols'] = Object.values(maxColWidths).map(colWidth => ({wch: colWidth + 1}));

      utils.book_append_sheet(wb, ws, sheetName);

      writeFileXLSX(wb, sheetName + '.xlsx');
    },
    getFirstDateOfMonthYear(year, month) {
      return moment({ year, month: month, day: 1 }).toDate();
    },
    getLastDateOfMonthYear(year, month) {
      return moment({ year, month: month }).endOf('month').toDate();
    },
    getPreviousMonthDate() {
      return moment().subtract(1, 'month');
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.monthly-company-report-email {
  width: 250px;
}

.positions-chart {
  height: calc(100vh - 65px) !important;
}

// Mobile:
@media (max-width: $breaking-point) {
  label {
    width: 100%;
  }
}
</style>
